import Editor from "@monaco-editor/react";
import { Box } from "@mui/material";
import { ThemeMode } from "../../../../constants/themes";
import { useTheme } from "../../../../context/ThemeContext";
import styles from "../ApiReferenceDialog.module.scss";

interface ApiReferenceCodeEditorProps {
	code: string;
	language: string;
}

const ApiReferenceCodeEditor = ({ code, language }: ApiReferenceCodeEditorProps) => {
	const { mode } = useTheme();

	const theme = mode === ThemeMode.Dark || mode === ("labs" as ThemeMode) ? "vs-dark" : "vs-light";
	return (
		<Box className={styles.editorContainer}>
			<Editor
				defaultLanguage={language === "nodejs" ? "javascript" : language}
				theme={theme}
				value={code}
				options={{
					lineNumbers: "on",
					minimap: { enabled: false },
					wordWrap: "off",
					tabSize: 4,
					fontSize: 14,
					readOnly: true,
					scrollBeyondLastLine: false,
					automaticLayout: true,
					scrollbar: {
						verticalScrollbarSize: 6,
						horizontalScrollbarSize: 6,
						verticalSliderSize: 6,
						horizontalSliderSize: 6,
						arrowSize: 6,
						useShadows: false,
						verticalHasArrows: false,
						horizontalHasArrows: false,
					},
				}}
			/>
		</Box>
	);
};

export default ApiReferenceCodeEditor;
